import React from "react";
import SingleExclusionRuleContent from "../components/exclusionRules/single-exclusionRule-content";
const SingleExclusionRule = () => {
  return <SingleExclusionRuleContent />;
};

export default SingleExclusionRule;
